// --- src/api/createDevice.js ---
import apiurl from './apiurl';
import axios from 'axios';

const createDevice = async (idToken, deviceData) => {
  try {
    const result = await axios({
      method: 'POST',
      url: apiurl + 'createDevice',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': "Bearer " + idToken
      },
      data: deviceData,
      crossdomain: true,
    });
    return result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export default createDevice;